var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('audio',{ref:"musicControl",attrs:{"src":require('./bell.mp3')}})])}
var staticRenderFns = []

export { render, staticRenderFns }